import { Spacing, SpacingValue } from '../../theme/type';
import { HxType } from './type';

const MARGIN_BOTTOM_FALLBACK: Record<HxType, SpacingValue> = {
  h1: '2rem',
  h2: { md: '2rem', xs: '1rem' },
  h3: { md: '1rem', xs: '0.75rem' },
  h4: { md: '1rem', xs: '0.75rem' },
};

export function getMarginFallback(headingType: HxType): Spacing {
  return { bottom: MARGIN_BOTTOM_FALLBACK[headingType] };
}
